import DateRange from './date-range';
import {END_OF_TODAY, END_OF_YESTERDAY, START_OF_TODAY, START_OF_YESTERDAY} from './presets';
import {DateRangeType, TimeUnit} from './types';

export default class InsightsTimePickerDateRange extends DateRange {
  static get presetOptions() {
    return [
      {
        label: `Current day`,
        value: {
          from: START_OF_TODAY,
          to: END_OF_TODAY,
          type: DateRangeType.Between,
        },
      },
      {
        label: `Previous day`,
        value: {
          from: START_OF_YESTERDAY,
          to: END_OF_YESTERDAY,
          type: DateRangeType.Between,
        },
      },
      {
        label: `Last 96 hours`,
        value: {
          type: DateRangeType.RelativeAfter,
          window: {
            unit: TimeUnit.Hour,
            value: 96,
          },
        },
      },
      {
        label: `Last 30 days`,
        value: {
          type: DateRangeType.RelativeAfter,
          window: {
            unit: TimeUnit.Day,
            value: 30,
          },
        },
      },
      {
        label: `Last 24 weeks`,
        value: {
          type: DateRangeType.RelativeAfter,
          window: {
            unit: TimeUnit.Week,
            value: 24,
          },
        },
      },
      {
        label: `Last 12 months`,
        value: {
          type: DateRangeType.RelativeAfter,
          window: {
            unit: TimeUnit.Month,
            value: 12,
          },
        },
      },
    ];
  }
}
